import { ContasPagarCopiaForm } from "../../../presentation/schemas/ContasPagar_lista/ContasPagar_copia";
import { ICopiaContasPagarUseCase } from "../../../presentation/useCases/create/copia_contas_pagar_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * CopiaContasReceberUseCase
 */

export class CopiaContasPagarUseCase implements ICopiaContasPagarUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async copiaContasPagar(
    form: ContasPagarCopiaForm
  ): Promise<void> {
    await this.repository.copiaContasPagar(form);
  }

}


